/* eslint-disable jsx-a11y/no-onchange */
import React, { Component } from 'react';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  width: 100%;
  > select {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export class LocationDropdown extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    this.props.onChange(e.target.options[e.target.selectedIndex].value);
  }

  render() {
    const {items = []} = this.props;

    return (
      <DropdownWrapper>
        <select
          id="location"
          name="location"
          onChange={this.handleChange}
        >
          <option value='none'>
            none
          </option>
          {items && items.filter((item) => item && item.length).map((item, i) => (
            <option
              key={`${item}-${i}`}
              value={item}
            >
              {item}
            </option>
          ))}
        </select>
      </DropdownWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationDropdown.js